import type { ConversationTemplateVariablesProviderProps } from '@ztechapps/webui.contract'
import type { TemplateVariables } from './Context'
import { useRequesterTemplateVariables } from './template-helpers/useRequesterTemplateVariables'

export const RequesterTemplateVariablesProvider = ({
  chat,
  children,
}: ConversationTemplateVariablesProviderProps<TemplateVariables>) => {
  const templateVariables = useRequesterTemplateVariables({ requester: chat?.requester, sender: chat?.sender })

  return children({ templateVariables })
}
